
import React from 'react';
import { Language, ServiceDefinition } from '../../types';
import ServicesModal from './ServicesModal';
import ServicesSidebar from './ServicesSidebar';
import ServicesHeader from './ServicesHeader';
import ServicesGrid from './ServicesGrid';

interface ServicesComponentProps {
  language: Language;
  categories: { id: string; label: string; icon: string }[];
  activeCategory: string;
  searchQuery: string;
  filteredServices: ServiceDefinition[];
  selectedService: ServiceDefinition | null;
  isSidebarOpen: boolean;
  isPro: boolean;
  
  onSetActiveCategory: (id: string) => void;
  onSetSearchQuery: (q: string) => void;
  onSelectService: (service: ServiceDefinition | null) => void;
  onToggleSidebar: () => void;
  onRunService: (service: ServiceDefinition) => void;
  onAutomateService: (service: ServiceDefinition) => void;
  onOpenPlans: () => void;
}

const ServicesComponent: React.FC<ServicesComponentProps> = (props) => {
  const { 
    language, categories, activeCategory, searchQuery, filteredServices, selectedService, 
    isSidebarOpen, isPro, onSetActiveCategory, onSetSearchQuery, onSelectService, 
    onToggleSidebar, onRunService, onAutomateService, onOpenPlans 
  } = props;

  const isRtl = language === 'ar';

  return (
    <div className="flex-1 flex h-full bg-slate-50 dark:bg-[#08080a] relative overflow-hidden">
      
      {selectedService && (
        <ServicesModal 
          language={language}
          selectedService={selectedService}
          onClose={() => onSelectService(null)}
          onRunService={onRunService}
          onAutomateService={onAutomateService}
        />
      )}

      <ServicesSidebar 
        language={language}
        categories={categories}
        activeCategory={activeCategory}
        isSidebarOpen={isSidebarOpen}
        onSetActiveCategory={onSetActiveCategory}
        onOpenPlans={onOpenPlans}
      />

      <main className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <ServicesHeader 
          language={language}
          categories={categories}
          activeCategory={activeCategory}
          searchQuery={searchQuery}
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={onToggleSidebar}
          onSetSearchQuery={onSetSearchQuery}
          onSetActiveCategory={onSetActiveCategory}
          isRtl={isRtl}
        />

        <ServicesGrid 
          language={language}
          filteredServices={filteredServices}
          isPro={isPro}
          onSelectService={onSelectService}
        />
      </main>
    </div>
  );
};

export default ServicesComponent;
